/**
 * Created by jzj on 2018/10/3.
 */
'use strict'

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'

const aboutLocationImg = require('./static/location.png')

const en = {
  language: 'Language',
  languageName: 'English',
  comingSoon: '(coming soon)',
  relatedDapps: 'Related DApps',
  allCategories: 'All Category',
  categoryRanking: 'Category Ranking',
  searchDApps: 'Search DApps',
  statistics: 'Statistics',
  ok: 'OK',
  collections: {
    recommend: 'Recommend',
    popular: 'Most Popular',
    recent: 'Recent Added',
    highRated: 'High Rated'
  },
  menu: {
    menu: 'Menu',
    home: 'Home',
    submit: 'Submit DApp',
    blog: 'Blog',
    about: 'About Us',
    ranking: 'Ranking',
  },
  submit: {
    agreementsBefore: 'I agree to the ',
    agreementsLink: 'privacy policy',
    agreementsAfter: '',
    agreementsRequire: 'You need to agree to our privacy policy.',
    stepFillTable: 'Fill The Table',
    stepConfirm: 'Confirm Information',
    stepComplete: 'Complete',
    prevStep: 'Previous Step',
    nextStep: 'Next Step',
    submit: 'Submit',
    success: 'Submit Success!'
  },
  column: {
    name: 'Name',
    name_en_US: 'Name (English)',
    name_zh_CN: 'Name (Chinese)',
    name_ja: 'Name (Japanese)',
    description: 'Description',
    description_en_US: 'Description (English)',
    description_zh_CN: 'Description (Chinese)',
    description_ja: 'Description (Japanese)',
    index: 'Index',
    email: 'Email',
    logo: 'Logo',
    picture: 'Picture',
    website: 'Website',
    url: 'DApp URL',
    platform: 'Platform',
    contracts: 'Smart Contract',
    category: 'Category',
    promotion: 'I want to promote my DApp to attract more users',
    agreements: '',

    balance: 'Balance',
    user1d: '24h Users',
    user7d: '7d Users',
    user30d: '30d Users',
    userAll: 'All Users',
    value1d: '24h Volume',
    value7d: '7d Volume',
    value30d: '30d Volume',
    valueAll: 'All Volume',
    tx1d: '24h Tx',
    tx7d: '7d Tx',
    tx30d: '30d Tx',
    txAll: 'All Tx',

    socials: {
      facebook: 'Facebook',
      twitter: 'Twitter',
      github: 'Github',
      reddit: 'Reddit',
      telegram: 'Telegram',
      medium: 'Medium',
      discord: 'Discord',
      weibo: 'Weibo',
      wechatOfficialAccount: 'WeChat Official Account'
    }
  },
  columnHint: {
    name: 'Your DApp name',
    name_en_US: 'Your DApp name in English',
    name_zh_CN: 'Your DApp name in Chinese',
    name_ja: 'Your DApp name in Japanese',
    email: 'Your email address',
    website: 'DApp website URL',
    url: 'A URL that will launch this DApp directly',
    logo: 'DApp logo URL',
    picture: 'DApp picture URL',
    category: 'Select your DApp category',
    contracts: 'One by line',
    description: 'Your DApp description',
    description_en_US: 'Your DApp description in English',
    description_zh_CN: 'Your DApp description in Chinese',
    description_ja: 'Your DApp description in Japanese',

    socials: {
      facebook: 'Facebook URL',
      twitter: 'Twitter URL',
      github: 'Github URL',
      reddit: 'Reddit URL',
      telegram: 'Telegram URL',
      medium: 'Medium URL',
      discord: 'Discord URL',
      weibo: 'Weibo URL',
      wechatOfficialAccount: 'WeChat Official Account'
    }
  },
  columnRequire: {
    name: 'Please input your DApp name (at least one language)',
    email: 'Please input your email correctly',
    website: 'Please input your DApp website correctly',
    url: 'Please input URL correctly',
    logo: 'Please input your DApp logo URL correctly',
    picture: 'Please input your DApp picture URL correctly',
    category: 'Please select your DApp category',
    contracts: 'Please input your DApp smart contract address, one by line',
    description: 'Please input your DApp description (at least one language)',

    socials: {
      facebook: 'Facebook should be a URL',
      twitter: 'Twitter should be a URL',
      github: 'Github should be a URL',
      reddit: 'Reddit should be a URL',
      telegram: 'Telegram should be a URL',
      medium: 'Medium should be a URL',
      discord: 'Discord should be a URL',
      weibo: 'Weibo should be a URL',
      wechatOfficialAccount: 'WeChatOfficialAccount'
    }
  },
  content: {
    about: '<p>DAppChaser is a distributed organization focusing on blockchain-based innovations and DApp developments.</p>' +
      '<h3>Services we offer:</h3>' +
      '<ul>' +
      '<li>Data analysis</li>' +
      '<li>Industry consulting and branding</li>' +
      '<li>Multilingual translation and community operations</li>' +
      '<li>Technical and legal support</li>' +
      '<li>Design support</li>' +
      '<li>Fundraising</li>' +
      '</ul>' +
      '<h3>Where are we?</h3>' +
      '<img src="' + aboutLocationImg + '">' +
      '<h3>Contract information</h3>' +
      '<p>' +
      'General Inquiries & User Support: <a href="mailto:contact@dappchaser.com">contact@dappchaser.com</a><br/>' +
      'Partnership Inquiries: <a href="mailto:erica@dappchaser.com">erica@dappchaser.com</a>' +
      '</p>' +
      '<h3>Risk Warning</h3>' +
      '<p>Cryptocurrency investment is subject to high market risk. Please make your investments cautiously. DAppChaser will make best efforts to provide the information, but will not be responsible for your investment losses.</p>'
  }
}

const zh = {
  searchDApps: '搜索DApps',
  ok: 'OK',
  language: '语言',
  languageName: '简体中文',
  relatedDapps: '相似推荐',
  comingSoon: '(敬请期待)',
  allCategories: '全部分类',
  categoryRanking: '分类排行',
  statistics: '数据统计',
  collections: {
    recommend: '编辑推荐',
    popular: '最受欢迎',
    recent: '最近添加',
    highRated: '评价最高'
  },
  menu: {
    menu: '菜单',
    home: '首页',
    submit: '提交DApp',
    blog: '博客',
    about: '关于我们',
    ranking: '排行榜',
  },
  submit: {
    agreementsBefore: '我同意',
    agreementsLink: '隐私声明',
    agreementsAfter: '',
    agreementsRequire: '请勾选同意隐私声明',
    stepFillTable: '填写信息',
    stepConfirm: '确认信息',
    stepComplete: '完成',
    prevStep: '上一步',
    nextStep: '下一步',
    submit: '提交',
    success: '提交成功！'
  },
  column: {
    name: '名称',
    name_en_US: '名称（英文）',
    name_zh_CN: '名称（中文）',
    name_ja: '名称（日文）',
    description: '描述',
    description_en_US: '描述（英文）',
    description_zh_CN: '描述（中文）',
    description_ja: '描述（日文）',
    index: '排名',
    email: '邮箱',
    logo: 'Logo',
    picture: '图片',
    website: '网站',
    url: 'DApp启动地址',
    platform: '平台',
    contracts: '合约地址',
    category: '分类',
    promotion: '我希望参与DApp宣传合作计划',

    balance: '余额',
    user1d: '24h用户数',
    user7d: '7d用户数',
    user30d: '30d用户数',
    userAll: '累计用户数',
    value1d: '24h交易额',
    value7d: '7d交易额',
    value30d: '30d交易额',
    valueAll: '累计交易额',
    tx1d: '24h交易笔数',
    tx7d: '7d交易笔数',
    tx30d: '30d交易笔数',
    txAll: '总计交易笔数',

    socials: {
      facebook: 'Facebook',
      twitter: 'Twitter',
      github: 'Github',
      reddit: 'Reddit',
      telegram: 'Telegram',
      medium: 'Medium',
      discord: 'Discord',
      weibo: '微博',
      wechatOfficialAccount: '微信公众号'
    }
  },
  columnHint: {
    name: 'DApp名称',
    name_en_US: 'DApp名称（英文）',
    name_zh_CN: 'DApp名称（中文）',
    name_ja: 'DApp名称（日文）',
    email: '你的邮箱地址',
    website: 'DApp网站URL',
    url: 'DApp启动地址',
    logo: 'DApp logo URL',
    picture: 'DApp图片URL',
    category: '选择DApp的分类',
    contracts: '每行一个地址',
    description: '关于所提交DApp的描述文字',
    description_en_US: '描述文字（英文）',
    description_zh_CN: '描述文字（简体中文）',
    description_ja: '描述文字（日文）',

    socials: {
      facebook: 'Facebook URL',
      twitter: 'Twitter URL',
      github: 'Github URL',
      reddit: 'Reddit URL',
      telegram: 'Telegram URL',
      medium: 'Medium URL',
      discord: 'Discord URL',
      weibo: '微博URL',
      wechatOfficialAccount: '微信公众号'
    }
  },
  columnRequire: {
    name: '请输入DApp名称，至少输入一种语言',
    email: '请准确输入邮箱，例如admin@example.com',
    website: '请准确输入网站，例如https://www.example.com',
    logo: '请准确输入Logo地址，例如https://www.example.com/logo.png',
    picture: '请准确输入图片地址，例如https://www.example.com/picture.png',
    category: '请选择分类',
    contracts: '请输入DApp合约地址，多个地址每行一个',
    description: '请输入DApp介绍，至少输入一种语言',
    url: '请准确输入地址，例如https://www.example.com',

    socials: {
      facebook: '填写DApp Facebook页面的URL链接',
      twitter: '填写DApp Twitter页面的URL链接',
      github: '填写DApp Github页面的URL链接',
      reddit: '填写DApp Reddit页面的URL链接',
      telegram: '填写DApp 电报群邀请链接',
      medium: '填写DApp Medium页面的URL链接',
      discord: '填写DApp Discord邀请链接',
      weibo: '填写DApp微博页面的URL链接',
      wechatOfficialAccount: '填写DApp微信公众号的账号'
    }
  },
  content: {
    about: '<p>DAppChaser是一个分布式组织，旨在追踪全球区块链创新动态，聚焦DApp（去中心化应用）专业测评与开发进展。</p>' +
      '<h3>我们提供：</h3>' +
      '<ul>' +
      '<li>数据分析</li>' +
      '<li>产业资讯和品牌推广</li>' +
      '<li>多语种翻译和社区运营</li>' +
      '<li>技术和法律支持</li>' +
      '<li>设计支持</li>' +
      '<li>DApp Fund支持</li>' +
      '</ul>' +
      '<h3>我们位于：</h3>' +
      '<img src="' + aboutLocationImg + '">' +
      '<h3>联系方式</h3>' +
      '<p>' +
      '一般咨询&用户支持：<a href="mailto:contact@dappchaser.com">contact@dappchaser.com</a><br/>' +
      '合作咨询：<a href="mailto:erica@dappchaser.com">erica@dappchaser.com</a><br/>' +
      '</p>' +
      '<h3>风险提示</h3>' +
      '<p>数字货币是一种高风险的投资方式，请投资者谨慎购买，并注意投资风险。DAppChaser会提供信息，但不对投资行为承担担保、赔偿等责任。</p>'
  }
}

const ja = {
  languageName: '日本語',
}

Vue.use(VueI18n)

function getDefaultLanguage () {
  let lang = Cookies.get('language')
  if (!lang) {
    lang = (navigator.language || navigator.browserLanguage || 'en').toLowerCase().substr(0, 2)
    Cookies.set('language', lang)
  }
  return lang
}

const i18n = new VueI18n({
  // set locale
  // options: en or zh
  locale: getDefaultLanguage(),
  fallbackLocale: 'en',
  // set locale messages
  // https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
  messages: {
    en: en,
    zh: zh,
    ja: ja
  },
  // TODO 开启以检查是否有漏掉的文本翻译
  silentTranslationWarn: true,
  missing: key => ''
})

export function getLanguageList () {
  return [
    {key: 'en', name: en.languageName},
    {key: 'zh', name: zh.languageName},
    // {key: 'ja', name: ja.languageName}
  ]
}

export function setLanguage (vue, lang) {
  if (lang !== vue.$i18n.locale) {
    Cookies.set('language', lang)
    vue.$i18n.locale = lang
    vue.$router.go(0)
  }
}

const apiLang = {
  zh: 'zh_CN',
  en: 'en_US',
  ja: 'ja'
}

export function getApiLang () {
  let lang = Cookies.get('language')
  return apiLang[lang || 'en']
}

export default i18n



// WEBPACK FOOTER //
// ./src/lang.js